// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2nE_r","label":"Radio_label__1Qblb","checkMark":"Radio_checkMark__19-hy","disabled":"Radio_disabled__1B7wa"};